<div class="c-progressbagInfo">
  <slotcom-navigation-button
    type="close"
    (click)="closeModal()">
  </slotcom-navigation-button>

  <div class="c-progressbagInfo__container">
    <span class="text title">{{ 'home.live-ops.progressbag.modal-info.title' | translate }}</span>

    <div class="c-progressbagInfo__explanation">
      <div class="explanation">
        <div
          class="image"
          theming
          themingGroup="progressivebag"
          themingAsset="step-1"
          [themingOverride]="progressbag()?.assets"></div>
        <span class="text subtitle">{{ 'home.live-ops.progressbag.modal-info.step-1' | translate }}</span>
      </div>

      <div
        class="arrow arrow-1"
        theming
        themingGroup="progressivebag"
        themingAsset="arrow"
        [themingOverride]="progressbag()?.assets"></div>

      <div class="explanation">
        <div
          class="image"
          theming
          themingGroup="progressivebag"
          themingAsset="step-2"
          [themingOverride]="progressbag()?.assets"></div>
        <span class="text subtitle">{{ 'home.live-ops.progressbag.modal-info.step-2' | translate }}</span>
      </div>

      <div
        class="arrow arrow-2"
        theming
        themingGroup="progressivebag"
        themingAsset="arrow"
        [themingOverride]="progressbag()?.assets"></div>

      <div class="explanation">
        <div
          class="image"
          theming
          themingGroup="progressivebag"
          themingAsset="step-3"
          [themingOverride]="progressbag()?.assets"></div>
        <span class="text subtitle">{{ 'home.live-ops.progressbag.modal-info.step-3' | translate }}</span>
      </div>
    </div>

    <div class="c-progressbagInfo__footer">
      <slotcom-button
        class="c-button--purple"
        (safeClick)="openInfo2()"
        audioType="functionality">
        {{ 'home.buttons.how-get-points' | translate | uppercase }}
      </slotcom-button>
    </div>
  </div>
</div>
